import { ApiError } from 'common/repositories/common.model';
import EmptyView from 'components/common/empty-view';
import LoadingComponent from 'components/common/loading';
import React from 'react';

import ErrorView from './error-view-component';
import ScaffoldViewComponent from './scaffold-view-component';
import { errorStatusContent } from './scaffold-view-component/constant';

interface WrapperProps {
  isLoading?: boolean;
  error?: ApiError | boolean | null;
  loadingComponent?: React.ReactNode;
  errorComponent?: React.ReactNode;
  component: React.ReactNode;
  errorVertical?: boolean;
  onRetry?: () => void;
  emptyText?: string;
  showEmptyText?: boolean;
  showEmptyComponent?: boolean;
}

export default function FetchWrapperComponent(props: WrapperProps) {
  const {
    isLoading = false,
    error,
    onRetry,
    loadingComponent = <LoadingComponent />,
    component,
    errorComponent,
    errorVertical = false,
    showEmptyComponent,
  } = props;

  if (isLoading) {
    return <>{loadingComponent}</>;
  } else if (error) {
    if (typeof error !== 'boolean') {
      const errorCode = error.statusCode;
      if (errorCode) {
        const content = errorStatusContent[errorCode];
        if (content) {
          return (
            <ScaffoldViewComponent
              title={content.title}
              subtitle={content.subtitle}
              message={error.message ?? content.message}
              isShowRedirectLogin={errorCode === 401}
              onRetry={onRetry}
              isShowCloseTab
            />
          );
        }
      }
    }

    if (errorComponent) {
      return <>{errorComponent}</>;
    }

    return <ErrorView vertical={errorVertical} refetch={onRetry} />;
  }

  if (showEmptyComponent) {
    return <EmptyView />;
  }

  return <>{component}</>;
}
